import { h, Fragment } from 'preact';
import { useEffect } from 'preact/hooks';
import ProductCard from '../product-card/product-card';
import Pagination from './pagination';

const ProductGrid = ({isB2B, products, paginate, search }) => {

		const filtersInit = () => {
			const buttonFilterOpen = document.querySelector('[data-filter-open]');
			const collapseTriggers = document.querySelectorAll('[data-collapse-btn]');
			const buttonClose = document.querySelector('[data-close]');
			const overlay = document.querySelector('[data-overlay]');
			const overlayBg = overlay.querySelector('[data-overlay-bg]');
			const body = document.querySelector('body');
			const filterSection = document.querySelector('[data-section-filters]')?.parentElement;

			const toggleFilterControls = () => isB2B && filterSection.classList.add('ns-header-controls');

			
			const toggleOverlay = () => {
				body.classList.toggle('overflow-hidden');
				overlay.classList.toggle('hidden');
			}

			buttonFilterOpen.addEventListener('click', toggleOverlay);
			overlayBg.addEventListener('click', toggleOverlay);
			buttonClose.addEventListener('click', toggleOverlay);
			toggleFilterControls();

			collapseTriggers.forEach((button) => {
				button.addEventListener('click', (e) => {
					e.preventDefault();
					const collapseWrapper = button.nextElementSibling;
					const buttonSvg = button.querySelector('svg');
					const ariaExpanded = button.getAttribute('aria-expanded') === 'true' ? 'false' : 'true';

					button.setAttribute('aria-expanded',ariaExpanded);
					buttonSvg.classList.toggle('rotate-180');
					collapseWrapper.classList.toggle('hidden');
				})
			})
		}

		useEffect(filtersInit, [])

	return (
		<>
		
			{search?.terms && (
				search.results_count 
					? <div className="text-primary py-4 px-3 lg:py-5 lg:px-6"><h1>{window.TMW.Strings.search.resultsForQuery} &quot;{search.terms}&quot;</h1></div> 
					: <div className="px-3 md:px-5 py-12"><h3 className="text-primary text-center">{window.TMW.Strings.search.noResultsForQuery} &quot;{search.terms}&quot;</h3></div>
			)}
			<div className="px-3 md:px-5 py-3 md:py-4 grid grid-cols-2 gap-1 md:gap-2 md:grid-cols-4">
				{products.map((product) => (
					<ProductCard
						key={product.id}
						product={product}
						classes={product.metafields.portrait === true ? 'col-span-1' : 'col-span-2'}
						isB2B={isB2B} />
				))}
			</div>
			{paginate && search.results_count !== 0 && (
				<Pagination paginate={paginate} />
			)}
		</>
	)
}
export default ProductGrid;
